const BAGITEMS_GET_SUCCESS = 'BAGITEMS_GET_SUCCESS';

export default {
    BAGITEMS_GET_SUCCESS,
};
